"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContainerWithWhiteBorder = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.ContainerWithWhiteBorder = styled_components_1.default.div `
  border: 1px solid #fff;
  border-radius: 2px;
`;
//# sourceMappingURL=container-with-white-border.js.map